<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" class="mb-3">
        <p style="font-weight: bold; margin-bottom: 5px;">
          Please upload an Excel file containing the serial numbers to check.
        </p>

        <div style="display: inline-block; width: 300px;">
          <b-form-file
            v-model="uploadedFile"
            :state="Boolean(uploadedFile)"
            placeholder="Choose Excel file..."
            drop-placeholder="Drop Excel file here..."
            accept=".xls,.xlsx"
            size="sm"
            browse-text="Select File"
          ></b-form-file>

          <b-button
            class="mt-2"
            variant="primary"
            size="sm"
            :disabled="!uploadedFile || loadingUpload"
            @click="uploadFile"
          >
            <span v-if="loadingUpload">
              <b-spinner small type="border"></b-spinner> Uploading
            </span>
            <span v-else>Upload</span>
          </b-button>
        </div>
      </b-col>

      <b-col lg="12" v-if="invalidSerials.length > 0" class="mb-3">
        <b-card title="Invalid Serial Numbers" class="mb-3">
          <ul>
            <li v-for="(serial, idx) in invalidSerials" :key="idx">{{ serial }}</li>
          </ul>
        </b-card>
      </b-col>

      <b-row class="w-100" v-if="tableData.length > 0">
        <b-col
          lg="12"
          style="display:block; text-align:right;padding-bottom:15px;font-size:1.2em;"
        >
          <b-button
            class="download-button"
            variant="primary"
            size="lg"
            @click="downloadExcel()"
          >
            <LoadingCard
              height="20px"
              width="20px"
              v-if="loadingDownloadExcel"
            ></LoadingCard>
            <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
            Download
          </b-button>
        </b-col>
        <b-col lg="12">
          <c-table
            :table-data="tableData"
            :fields="tableFields"
          ></c-table>
        </b-col>
      </b-row>
      <b-row style="display:flex; justify-content: center;" v-if="tableData.length > 0">
        <LoadingCard v-if="loadingDownload"></LoadingCard>
      </b-row>
    </b-row>
  </div>
</template>

<script>
import LoadingCard from "@/components/shared/LoadingCard.vue";
import cTable from "../tables/Table.vue";

export default {
  name: "tables",
  data() {
    return {
      uploadedFile: null,
      loadingUpload: false,
      loadingDownload: false,
      loadingDownloadExcel: false,
      invalidSerials: [],
      validSerials: [],
      tableData: [],
      tableFields: [
        {key: "fnsid", label: "FNSID", sortable: true},
        {key: "locat", label: "Location"},
        {key: "sernm", label: "Serial#", sortable: true},
        {key: "pMake", label: "Manufacturer", sortable: true, style: "width:250px"},
        {key: "pMode", label: "Model"},
        {key: "compl", label: "Complaint", sortable: true, tdClass: "complaintClass"},
        {key: "loctn", label: "Status", sortable: true},
        {key: "price", label: "Price", sortable: true},
      ],
    };
  },
  components: {LoadingCard, cTable},
  methods: {
    async uploadFile() {
      if (!this.uploadedFile) return;
      this.loadingUpload = true;

      try {
        const formData = new FormData();
        formData.append("serialNumbers", this.uploadedFile);

        const res = await this.$http.post(
          "api/arris/tables/searchBySerialNumber.php",
          formData
        );

        this.invalidSerials = res.data.invalid || [];
        this.validSerials = res.data.valid || [];

        if (this.validSerials.length) {
          const tableRes = await this.$http.get(
            "api/arris/tables/shipped.php"
            , {
              params: {
                serialNumbers: this.validSerials
              }
            });
          this.tableData = tableRes.data.records || [];
        } else {
          this.tableData = [];
          if(res.data.message) {
            alert(res.data.message);
          }
        }
      } catch (err) {
        this.tableData = [];
      } finally {
        this.loadingUpload = false;
      }
    },

    async downloadExcel() {
      if (!this.tableData.length) return;

      this.loadingDownloadExcel = true;
      try {
        const res = await this.$http.get(
          "api/arris/tables/shipped.php",
          {
            params: {
              serialNumbers: this.validSerials,
              xml: "true"
            },
            responseType: "blob"
          }
        );

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "TableReport.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err) {
      } finally {
        this.loadingDownloadExcel = false;
      }
    },
  },
};
</script>
<style>
.download-button {
  width: 150px;
  margin: auto;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.sk-double-bounce {
  display: inline-block;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}

.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}
</style>
